<div class="section-header" mat-dialog-title>
    <mat-icon class="section-icon">play_circle_outline</mat-icon>
    <span class="section-title">{{ 'general.preview' | transloco }}</span>
    <button mat-icon-button class="ss-dialog-close-btn" mat-dialog-close>
        <mat-icon>close</mat-icon>
    </button>
</div>

<div mat-dialog-content class="dialog-body">
    <mat-tab-group animationDuration="0ms" mat-stretch-tabs="false" mat-align-tabs="start" class="modern-tabs">
        <!-- PLAY TAB -->
        <mat-tab>
            <ng-template mat-tab-label>
                <div class="tab-label">
                    <mat-icon>play_arrow</mat-icon>
                    <span>{{ 'general.play' | transloco }}</span>
                </div>
            </ng-template>

            <div class="tab-content">
                <!-- Scene Selector Section -->
                <div class="scene-selector-section">
                    @if (!data.isSlider) {
                        <app-scene-selector
                            [currentSceneId]="data.selectedSceneId"
                            [currentSceneName]="'current scene'"
                            [selectedSceneId]="previewSceneId"
                            [showJump]="true"
                            (changeSelectedScene)="changePreviewScene($event)">
                        </app-scene-selector>
                    } @else {
                        <div class="slider-badge">
                            <mat-icon>view_carousel</mat-icon>
                            <span>{{ data.sliderName | PipeTruncate:['25'] }}</span>
                            <span class="badge-label">slider preview</span>
                        </div>
                    }
                </div>

                <!-- Preview Options Grid -->
                <div class="preview-options-grid">
                    <!-- Left: Size Options -->
                    <div class="options-card">
                        <div class="card-header">
                            <mat-icon>aspect_ratio</mat-icon>
                            <span>preview size</span>
                        </div>
                        <div class="card-body">
                            <mat-radio-group [(ngModel)]="previewMode" (ngModelChange)="onPreviewModeChange()" class="preview-mode-group">
                                <!-- Custom Size Option -->
                                <div class="mode-option" [class.active]="previewMode === 'size'" (click)="previewMode = 'size'; onPreviewModeChange()">
                                    <mat-radio-button value="size">
                                        <div class="option-content">
                                            <mat-icon>straighten</mat-icon>
                                            <span class="option-label">custom size</span>
                                        </div>
                                    </mat-radio-button>
                                    <div class="size-inputs" [class.disabled]="previewMode !== 'size'">
                                        <mat-form-field appearance="outline" class="size-field">
                                            <mat-label>{{ 'general.width' | transloco }}</mat-label>
                                            <input matInput type="number" max="7680"
                                                   [(ngModel)]="previewSizeX"
                                                   (ngModelChange)="onPreviewSizeChange()"
                                                   inputrestriction="basic1"
                                                   autocomplete="off">
                                        </mat-form-field>
                                        <span class="size-separator">×</span>
                                        <mat-form-field appearance="outline" class="size-field">
                                            <mat-label>{{ 'general.height' | transloco }}</mat-label>
                                            <input matInput type="number" max="7680"
                                                   [(ngModel)]="previewSizeY"
                                                   (ngModelChange)="onPreviewSizeChange()"
                                                   inputrestriction="basic1"
                                                   autocomplete="off">
                                        </mat-form-field>
                                    </div>
                                </div>

                                <!-- Percentage Option -->
                                <div class="mode-option" [class.active]="previewMode === 'percent'" (click)="previewMode = 'percent'; onPreviewModeChange()">
                                    <mat-radio-button value="percent">
                                        <div class="option-content">
                                            <mat-icon>percent</mat-icon>
                                            <span class="option-label">percentage</span>
                                        </div>
                                    </mat-radio-button>
                                    <div class="percent-select" [class.disabled]="previewMode !== 'percent'">
                                        <mat-form-field appearance="outline" class="percent-field">
                                            <mat-label>{{ 'general.percent' | transloco }}</mat-label>
                                            <mat-select [(ngModel)]="previewPercent" (ngModelChange)="onPreviewPercentChange()">
                                                @for (p of percentages; track p) {
                                                    <mat-option [value]="p">{{ p }}%</mat-option>
                                                }
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </mat-radio-group>
                        </div>
                    </div>

                    <!-- Right: Quick Actions -->
                    <div class="options-card">
                        <div class="card-header">
                            <mat-icon>bolt</mat-icon>
                            <span>quick actions</span>
                        </div>
                        <div class="card-body">
                            <div class="actions-grid">
                                @if (data.isMainScene) {
                                    <button class="action-btn register-btn" (click)="onRegisterPlayer()">
                                        <mat-icon>queue_play_next</mat-icon>
                                        <span class="btn-label">{{ 'general.registerPlayer' | transloco }}</span>
                                    </button>
                                }
                                <button class="action-btn embed-btn" (click)="onWebEmbedded()">
                                    <mat-icon>code</mat-icon>
                                    <span class="btn-label">{{ 'general.webEmbedded' | transloco }}</span>
                                </button>
                                <button class="action-btn copy-btn" (click)="onCopyLink()">
                                    <mat-icon>content_copy</mat-icon>
                                    <span class="btn-label">{{ 'general.copyLink' | transloco }}</span>
                                </button>
                                <button class="action-btn qr-btn" (click)="onQrCode()">
                                    <mat-icon>qr_code_scanner</mat-icon>
                                    <span class="btn-label">{{ 'general.qrCode' | transloco }}</span>
                                </button>
                                                            </div>
                            <div class="remember-option">
                                <mat-checkbox [(ngModel)]="rememberSelection" (change)="changeRemeberSelection()">
                                    <span class="remember-label">{{ 'account.rememberMe' | transloco }}</span>
                                </mat-checkbox>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Preview Buttons -->
                <div class="preview-launch-section">
                    <div class="launch-buttons-row">
                        @if (canShowDownload) {
                            <button class="get-player-btn" (click)="onGetPlayer()">
                                <div class="btn-content">
                                    <mat-icon>shopping_cart</mat-icon>
                                    <span>{{ 'ai.downloadOrderPlayer' | transloco }}</span>
                                </div>
                                <div class="btn-shine"></div>
                            </button>
                        }
                        <button class="launch-btn"
                                (click)="onClickPlayPreview()"
                                [disabled]="(!previewSizeX || !previewSizeY || previewSizeX < 100 || previewSizeY < 100) && previewMode === 'size'">
                            <div class="btn-content">
                                <mat-icon>play_circle</mat-icon>
                                <span>{{ 'general.webPreview' | transloco }}</span>
                            </div>
                            <div class="btn-glow"></div>
                        </button>
                    </div>

                    @if (!data.isMainScene) {
                        <div class="warning-banner">
                            <mat-icon>warning</mat-icon>
                            <div class="warning-content">
                                <span class="warning-title">{{ 'general.warning' | transloco }} for {{ data.sceneMimeShort }} scene</span>
                                <span class="warning-text">{{ 'general.previewSpecial' | transloco }}</span>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </mat-tab>

        <!-- SOCIAL MEDIA TAB -->
        <mat-tab>
            <ng-template mat-tab-label>
                <div class="tab-label">
                    <mat-icon>share</mat-icon>
                    <span>{{ 'general.socialMedia' | transloco }}</span>
                </div>
            </ng-template>

            <div class="tab-content social-content">
                <!-- Header -->
                <div class="social-header">
                    <mat-icon>campaign</mat-icon>
                    <span>post scene <strong>[{{ data.sceneData.Player.$.label }}]</strong> to your favorite social network</span>
                </div>

                <!-- Social Platforms Grid -->
                <div class="social-platforms-section">
                    <div class="platforms-grid">
                        <!-- Row 1 -->
                        <div class="platform-card" [class.selected]="socialMediaSelection.isSelected('youtube')" (click)="selectSocialMedia(!socialMediaSelection.isSelected('youtube'), 'youtube')">
                            <div class="platform-icon youtube">
                                <fa-icon [icon]="['fab', 'youtube']"></fa-icon>
                            </div>
                            <span class="platform-name">Youtube</span>
                            <mat-checkbox [checked]="socialMediaSelection.isSelected('youtube')" (click)="$event.stopPropagation()"></mat-checkbox>
                        </div>

                        <div class="platform-card" [class.selected]="socialMediaSelection.isSelected('twitter')" (click)="selectSocialMedia(!socialMediaSelection.isSelected('twitter'), 'twitter')">
                            <div class="platform-icon twitter">
                                <fa-icon [icon]="['fab', 'twitter']"></fa-icon>
                            </div>
                            <span class="platform-name">X</span>
                            <mat-checkbox [checked]="socialMediaSelection.isSelected('twitter')" (click)="$event.stopPropagation()"></mat-checkbox>
                        </div>

                        <div class="platform-card" [class.selected]="socialMediaSelection.isSelected('facebook')" (click)="selectSocialMedia(!socialMediaSelection.isSelected('facebook'), 'facebook')">
                            <div class="platform-icon facebook">
                                <fa-icon [icon]="['fab', 'facebook']"></fa-icon>
                            </div>
                            <span class="platform-name">Facebook</span>
                            <mat-checkbox [checked]="socialMediaSelection.isSelected('facebook')" (click)="$event.stopPropagation()"></mat-checkbox>
                        </div>

                        <div class="platform-card" [class.selected]="socialMediaSelection.isSelected('instagram')" (click)="selectSocialMedia(!socialMediaSelection.isSelected('instagram'), 'instagram')">
                            <div class="platform-icon instagram">
                                <fa-icon [icon]="['fab', 'instagram']"></fa-icon>
                            </div>
                            <span class="platform-name">Instagram</span>
                            <mat-checkbox [checked]="socialMediaSelection.isSelected('instagram')" (click)="$event.stopPropagation()"></mat-checkbox>
                        </div>

                        <div class="platform-card" [class.selected]="socialMediaSelection.isSelected('linkedin')" (click)="selectSocialMedia(!socialMediaSelection.isSelected('linkedin'), 'linkedin')">
                            <div class="platform-icon linkedin">
                                <fa-icon [icon]="['fab', 'linkedin']"></fa-icon>
                            </div>
                            <span class="platform-name">LinkedIn</span>
                            <mat-checkbox [checked]="socialMediaSelection.isSelected('linkedin')" (click)="$event.stopPropagation()"></mat-checkbox>
                        </div>

                        <div class="platform-card" [class.selected]="socialMediaSelection.isSelected('tiktok')" (click)="selectSocialMedia(!socialMediaSelection.isSelected('tiktok'), 'tiktok')">
                            <div class="platform-icon tiktok">
                                <fa-icon [icon]="['fab', 'tiktok']"></fa-icon>
                            </div>
                            <span class="platform-name">TikTok</span>
                            <mat-checkbox [checked]="socialMediaSelection.isSelected('tiktok')" (click)="$event.stopPropagation()"></mat-checkbox>
                        </div>

                        <div class="platform-card" [class.selected]="socialMediaSelection.isSelected('telegram')" (click)="selectSocialMedia(!socialMediaSelection.isSelected('telegram'), 'telegram')">
                            <div class="platform-icon telegram">
                                <fa-icon [icon]="['fab', 'telegram']"></fa-icon>
                            </div>
                            <span class="platform-name">Telegram</span>
                            <mat-checkbox [checked]="socialMediaSelection.isSelected('telegram')" (click)="$event.stopPropagation()"></mat-checkbox>
                        </div>

                        <div class="platform-card" [class.selected]="socialMediaSelection.isSelected('pinterest')" (click)="selectSocialMedia(!socialMediaSelection.isSelected('pinterest'), 'pinterest')">
                            <div class="platform-icon pinterest">
                                <fa-icon [icon]="['fab', 'pinterest']"></fa-icon>
                            </div>
                            <span class="platform-name">Pinterest</span>
                            <mat-checkbox [checked]="socialMediaSelection.isSelected('pinterest')" (click)="$event.stopPropagation()"></mat-checkbox>
                        </div>

                        <div class="platform-card" [class.selected]="socialMediaSelection.isSelected('reddit')" (click)="selectSocialMedia(!socialMediaSelection.isSelected('reddit'), 'reddit')">
                            <div class="platform-icon reddit">
                                <fa-icon [icon]="['fab', 'reddit']"></fa-icon>
                            </div>
                            <span class="platform-name">Reddit</span>
                            <mat-checkbox [checked]="socialMediaSelection.isSelected('reddit')" (click)="$event.stopPropagation()"></mat-checkbox>
                        </div>

                        <div class="platform-card" [class.selected]="socialMediaSelection.isSelected('gmb')" (click)="selectSocialMedia(!socialMediaSelection.isSelected('gmb'), 'gmb')">
                            <div class="platform-icon google">
                                <fa-icon [icon]="['fab', 'google-drive']"></fa-icon>
                            </div>
                            <span class="platform-name">Google Business</span>
                            <mat-checkbox [checked]="socialMediaSelection.isSelected('gmb')" (click)="$event.stopPropagation()"></mat-checkbox>
                        </div>

                        <div class="platform-card" [class.selected]="socialMediaSelection.isSelected('fbg')" (click)="selectSocialMedia(!socialMediaSelection.isSelected('fbg'), 'fbg')">
                            <div class="platform-icon facebook">
                                <fa-icon [icon]="['fab', 'facebook']"></fa-icon>
                            </div>
                            <span class="platform-name">FB Groups</span>
                            <mat-checkbox [checked]="socialMediaSelection.isSelected('fbg')" (click)="$event.stopPropagation()"></mat-checkbox>
                        </div>
                    </div>
                </div>

                <!-- Post Configuration -->
                <div class="post-config-section">
                    <div class="config-row">
                        <div class="config-field">
                            <mat-form-field appearance="outline" class="full-width">
                                <mat-label>{{ 'general.text' | transloco }}</mat-label>
                                <mat-icon matPrefix>edit</mat-icon>
                                <input matInput type="text"
                                       [(ngModel)]="socialMediaTitle"
                                       (change)="isSocialPostReady()"
                                       (keyup)="isSocialPostReady()"
                                       inputrestriction="basic2"
                                       autocomplete="off">
                            </mat-form-field>
                        </div>
                        <div class="config-field resource-field">
                            <mat-form-field appearance="outline" class="full-width">
                                <mat-label>{{ 'general.resource' | transloco }}</mat-label>
                                <mat-icon matPrefix>image</mat-icon>
                                <input matInput type="text" [(ngModel)]="socialMediaResourceName" readonly>
                            </mat-form-field>
                            <button class="add-resource-btn" (click)="selectResource()" matTooltip="{{'general.addResource' | transloco}}">
                                <mat-icon>add_circle</mat-icon>
                            </button>
                        </div>
                    </div>

                    <div class="token-section">
                        <app-scene-social-token #appSceneSocialTokenApp [miniMode]="true" (changed)="onSocialKeyChanged($event)"></app-scene-social-token>
                    </div>

                    <!-- Post Button -->
                    <div class="post-action">
                        @if (socialPosting) {
                            <div class="posting-indicator">
                                <app-loading [size]="'24px'"></app-loading>
                                <span>posting to social media...</span>
                            </div>
                        } @else {
                            <button class="post-btn" [disabled]="socialPostDisabled" (click)="postToSocial()">
                                <mat-icon>send</mat-icon>
                                <span>{{ 'general.postToSocial' | transloco }}</span>
                            </button>
                        }
                    </div>
                </div>
            </div>
        </mat-tab>
    </mat-tab-group>
</div>
